export default "__VITE_ASSET__Chz8aHfW__"